export const start2021Forgiveness3508SSelector = (state) => ({
  advances: state.entities.advances,
  loanForgiveness: state.entities.loanForgiveness,
  portalRedesignEnabled: state.config.portalRedesignEnabled,
});
